// extracted by mini-css-extract-plugin
export default {"container":"photo_container__P1ypM","photo":"photo_photo__yxduh","blink":"photo_blink__v4Mma","blinker":"photo_blinker__VQNwx","gallery":"photo_gallery__JUvN4"};